/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popDaily.vue?vue&type=template&id=2cc5923e&scoped=true"
import script from "./popDaily.vue?vue&type=script&lang=js"
export * from "./popDaily.vue?vue&type=script&lang=js"
import style0 from "./popDaily.vue?vue&type=style&index=0&id=2cc5923e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc5923e",
  null
  
)

export default component.exports